import type { CommandGroupWithActions } from "@editor/utils/commands";

import React from "react";

import { useIsDebugMode } from "@editor/components/editor/debug/useIsDebugMode";
import { DEBUG_OPTIONS } from "@editor/constants/debug-options";
import { useLocalStorageState } from "@editor/hooks/useLocalStorage";

import twMerge from "@replo/design-system/utils/twMerge";
import { z } from "zod";

export function useDebugOptionsCommandItems(): CommandGroupWithActions["items"] {
  const isDebugMode = useIsDebugMode();

  if (!isDebugMode) {
    return {};
  }

  const items: CommandGroupWithActions["items"] = {};

  DEBUG_OPTIONS.forEach((option) => {
    /* eslint-disable react-hooks/rules-of-hooks */
    // biome-ignore lint/correctness/useHookAtTopLevel: This is safe because the loop is deterministic and hooks are called in the same order
    const [value, setValue] = useLocalStorageState(option.key, false, {
      schema: z.boolean(),
    });
    /* eslint-enable react-hooks/rules-of-hooks */

    items[option.key] = {
      label: `${option.label} (Currently ${value ? "ON" : "OFF"})`,
      icon: {
        type: "custom" as const,
        content: (
          <div className="flex h-[16px] w-[16px] items-center justify-center">
            <div
              className={twMerge(
                "h-[8px] w-[8px] rounded-full",
                value ? "bg-success-soft0" : "bg-surface",
              )}
            />
          </div>
        ),
      },
      onSelect: () => setValue(!value),
    };
  });

  return items;
}
